<template>
  <b-card id="page-add-client" no-body class="order-customer-select-card mt-2">
    <b-card-header class="client-select-header">
      <div class="client-select-heading">
        <div class="client-select-icon">
          <feather-icon icon="UserIcon" size="19" />
        </div>
        <div>
          <h4 class="mb-25">{{ $t(label("add_customer")) }}</h4>
          <small class="text-muted">{{ $t(label("selectCustomerHelp")) }}</small>
        </div>
      </div>
    </b-card-header>
    <b-card-body class="client-select-body">
      <b-row>
        <b-col cols="12">
          <b-col
            cols="12"
            class="p-0 d-flex justify-content-between align-items-start"
          >
            <validation-observer ref="clientform" class="w-100 mr-1">
              <b-form>
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('customer'))"
                  rules="required"
                >
                  <b-form-group
                    :label="$t(label('customer'))"
                    label-for="clients"
                    :state="errors.length > 0 ? false : null"
                  >
                    <v-select
                      input-id="clients"
                      v-model="localCustomer"
                      :options="formattedClients"
                      label="name"
                      :placeholder="$t(label('select'))"
                      @search="searchClientsAll"
                      :reduce="(option) => option"
                      @input="emitSelection($event)"
                    >
                      <span
                        slot="no-options"
                        click="$refs.clients.open = false"
                      >
                        {{ $t("sorryOption") }}
                      </span>
                      <template #list-footer>
                        <li
                          v-if="allClients.length > 0"
                          v-show="hasNextPageClients"
                          ref="loadClients"
                          class="loader"
                        >
                          {{ $t("loadingOption") }}
                        </li>
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-form>
            </validation-observer>

            <b-button class="mt-2" @click="onCreate" variant="primary">
              <feather-icon icon="UserPlusIcon" />
            </b-button>
          </b-col>

          <b-dropdown-divider
            v-if="localCustomer.idClient"
            style="list-style-type: none; padding: 0"
          />

          <!-- Info Client -->
          <b-col
            v-if="localCustomer.idClient"
            class="selected-customer-grid mt-2 p-0"
            cols="12"
          >
            <b-card-text class="selected-customer-item">
              <feather-icon
                icon="MailIcon"
                size="21"
                class="selected-customer-icon text-info"
              />
              <span>
                <small>{{ $t(label("email")) }}</small>
                <strong>{{ localCustomer.email || $t("pages.customers.noEmail") }}</strong>
              </span>
            </b-card-text>
            <b-card-text class="selected-customer-item">
              <feather-icon
                icon="SmartphoneIcon"
                size="21"
                class="selected-customer-icon darken-2"
              />
              <span>
                <small>{{ $t(label("phone")) }}</small>
                <strong>{{ localCustomer.phoneNumber || $t("pages.customers.noPhone") }}</strong>
              </span>
            </b-card-text>
            <b-card-text class="selected-customer-item">
              <feather-icon
                icon="TruckIcon"
                size="21"
                class="selected-customer-icon text-warning"
              />
              <span>
                <small>{{ $t(label("deliveryCost")) }}</small>
                <strong>{{ $t("free") }}</strong>
              </span>
            </b-card-text>
            <b-card-text class="selected-customer-item selected-customer-item--address">
              <feather-icon
                icon="MapPinIcon"
                size="21"
                class="selected-customer-icon text-danger"
              />
              <span class="w-100">
                <small>{{ $t(label("shippingAddress")) }}</small>
                <b-form-input
                  id="address"
                  v-model="localCustomer.shippingAddress"
                  class="mt-50"
                  :placeholder="$t('pages.customers.form.label.shippingAddress')"
                  @input="emitShipping"
                />
              </span>
            </b-card-text>
          </b-col>
        </b-col>

        <!-- <b-col v-if="!blockStatus" cols="12" sm="12" md="6" lg="6" xl="6">
            <h4 class="text-start">Agregar tipo pago</h4>
            <validation-observer ref="clientform">
                <b-form>
                  <validation-provider
                        #default="{ errors }"
                        :name="$t('pages.orders.table.tableHeader.pay_type')"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('pages.orders.table.tableHeader.pay_type')"
                          label-for="pay_taypes"
                          class="mt-2"
                          :state="errors.length > 0 ? false : null"
                        >
                          <v-select
                            input-id="pay_type"
                            v-model="paymentMethodSelected"
                            :options="allPaymentMethods"
                            :close-on-select="false"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="nameType"
                            :placeholder="$t('pages.orders.table.tableHeader.pay_type')"
                            :disabled="!isSaveMode"
                            multiple
                            @input="emitSelection()"
                            :reduce="(option) => option"
                          >
                            <span
                              slot="no-options"
                              click="$refs.typesCatSizes.open = false"
                              >{{ $t("sorryOption") }}</span
                            >
                          </v-select>
                          <b-form-invalid-feedback
                            :state="errors.length > 0 ? false : null"
                          >
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                </b-form>
              </validation-observer>
          </b-col> -->
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BForm,
  BFormSelect,
  BFormInvalidFeedback,
  VBTooltip,
  BCardText,
  BDropdownDivider,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import router from "@/router";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import { allClientsByCompany } from "@core/api/request/clients";
// import { getPaymentMethodsCompany } from "@core/api/request/company";
import { getParams } from "@core/utils/utils";
import { add } from "lodash";
import { resolveNavDataRouteName } from "@/@core/layouts/utils";

const customer = {
  idClient: null,
  idCompany: null,
  name: null,
  email: null,
  shippingAddress: null,
  address: null,
  phoneNumber: null,
  guidCompany: null,
};

export default {
  props: {
    option: {
      type: Number,
      default: () => 1,
    },
    blockStatus: {
      type: Boolean,
      default: () => false,
    },
    order: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BForm,
    BFormSelect,
    BFormInvalidFeedback,
    VBTooltip,
    vSelect,
    BCardText,
    BDropdownDivider,
  },

  data() {
    return {
      loadingClients: false,
      hasNextPageClients: true,
      currentPageClients: 1,
      perPageClients: 20,
      companyGuid: null,
      searchClients: null,
      allClients: [],
      allPaymentMethods: [],
      totalPagesClients: null,
      observerClients: null,
      isSaveMode: true,
      paymentMethodSelected: [],

      localCustomer: this.mapOrder(this.order),
    };
  },
  computed: {
    formattedClients() {
      return this.allClients.map((client) => {
        // Si 'name' está vacío o null, asignamos un valor predeterminado
        client.name = client.name || "Nombre no disponible"; // o 'No asignado'
        return client;
      });
    },
  },

  watch: {
    order: {
      immediate: true,
      deep: true,
      handler(newOrder) {
        this.localCustomer = this.mapOrder(newOrder);
      },
    },
  },

  created() {
    localize("es");
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.initialize();
    // console.log("customer", this.customer);
    // this.paymentMethodSelected = this.customer.payment.map( model => {
    //   return {
    //     idCompanyPaymentMethods: model.idCompanyPaymentMethods,
    //   }
    // }) || []
    // console.log("paymentMethodSelected", this.paymentMethodSelected);

    const observers = [
      { name: "clients", callback: this.infiniteScrollClients },
    ];

    observers.forEach((observer) => {
      this[
        `observer${
          observer.name.charAt(0).toUpperCase() + observer.name.slice(1)
        }`
      ] = new IntersectionObserver(observer.callback);
    });
  },

  mounted() {},

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.resetData();
      this.loadData();
    },
  },

  directives: { "b-tooltip": VBTooltip, Ripple },

  methods: {
    async initialize() {
      await this.loadData();
    },

    async loadData() {
      await Promise.all([
        this.loadClientsByCompanie(),
        // this.loadPaymentsByCompanie(),
      ]);
    },

    emitSelection(value) {
      (this.localCustomer = value?.idClient
        ? Object.assign(value)
        : Object.assign(customer)),
        this.$emit("user-selected", this.localCustomer);
      if (this.paymentMethodSelected) {
        this.$emit("payments-selected", this.paymentMethodSelected);
      }
    },

    emitShipping(value) {
      this.localCustomer.shippingAddress = value;
      this.$emit("user-selected", this.localCustomer);
    },

    label(field) {
      return `pages.orders.form.label.${field}`;
    },

    resetData() {
      this.allClients = [];
      this.hasNextPageClients = true;
      this.currentPageClients = 1;
    },

    async onOpenClients() {
      if (this.hasNextPageClients) {
        await this.$nextTick();
        this.observerClients.observe(this.$refs.loadClients);
      }
    },

    mapOrder(order) {
      return {
        idClient: order?.idClient || null,
        idCompany: order?.idCompany || null,
        name: order?.name || null,
        email: order?.email || null,
        shippingAddress: order?.shippingAddress || null,
        address: order?.address || null,
        phoneNumber: order?.phoneNumber || null,
        guidCompany: order?.guidCompany || null,
      };
    },

    async searchClientsAll(value) {
      this.searchClients = value;
      this.allClients = [];
      this.currentPageClients = 1;
      this.hasNextPageClients = true;
      this.loadClientsByCompanie();
    },

    chargeParamsClients() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageClients}`);

      arrParams.push(`rows,${this.perPageClients}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      if (this.searchClients != null)
        arrParams.push(`name,${this.searchClients}`);
      arrParams.push(`active,${true}`);

      return getParams(arrParams);
    },

    async loadClientsByCompanie() {
      if (this.loadingClients || !this.hasNextPageClients) return;

      this.loadingClients = true;
      const param = this.chargeParamsClients();
      await allClientsByCompany(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.allClients = [...this.allClients, ...data?.items];
            this.currentPageClients = data?.currentPage;
            this.totalPagesClients = data?.totalPages || 0;
            this.hasNextPageClients =
              this.currentPageClients < this.totalPagesClients;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.hasNextPageClients = false;
        })
        .finally(() => {
          this.loadingClients = false;
        });
    },

    // async loadPaymentsByCompanie() {
    //   await getPaymentMethodsCompany(this.companyGuid)
    //     .then((resp) => {
    //       const data = _.get(resp, "data")
    //       this.allPaymentMethods = data.items
    //       console.log("allPaymentMethods", this.allPaymentMethods);
    //     })
    //     .catch((error) => {
    //       console.log("error", error);
    //     });
    // },

    async infiniteScrollClients(values) {
      const value = values[0];

      if (value.isIntersecting) {
        this.currentPageClients++;
        await this.loadClientsByCompanie();
      }
    },

    onCreate() {
      this.$router.push({
        name: "clients",
        // params: {
        //   option: 1, // option 1 to create
        // },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-customer-select-card {
  overflow: hidden;
  border: 0;
  border-radius: 0.65rem;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
}

.client-select-header,
.client-select-heading,
.client-select-icon,
.selected-customer-item {
  display: flex;
  align-items: center;
}

.client-select-header {
  padding: 1.5rem;
}

.client-select-heading {
  gap: 0.85rem;
}

.client-select-icon {
  justify-content: center;
  width: 2.65rem;
  height: 2.65rem;
  flex: 0 0 2.65rem;
  color: #7367f0;
  border-radius: 0.65rem;
  background: rgba(115, 103, 240, 0.12);
}

.client-select-body {
  padding: 0 1.5rem 1.5rem;
}

.selected-customer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.selected-customer-item {
  gap: 0.85rem;
  min-width: 0;
  padding: 1rem;
  margin-bottom: 0;
  border: 1px solid rgba(34, 41, 47, 0.08);
  border-radius: 0.5rem;
}

.selected-customer-item span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.15rem;
}

.selected-customer-item small {
  color: #b9b9c3;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
}

.selected-customer-item strong {
  overflow-wrap: anywhere;
}

.selected-customer-icon {
  flex: 0 0 21px;
}

.selected-customer-item--address {
  grid-column: 1 / -1;
  align-items: flex-start;
}

@media (max-width: 767.98px) {
  .client-select-body {
    padding: 0 1rem 1rem;
  }

  .selected-customer-grid {
    grid-template-columns: 1fr;
  }

  .selected-customer-item--address {
    grid-column: auto;
  }
}
</style>
